export const environment = {
  production: true,
  urlApi: 'https://be.demo.telar.ai/api/v1',
  encryptKey: '1203199302112022',
  queriesEntityId: 'e834b7a5-567e-4a97-bd93-8a9f8a2c9679',
  dynamicCardsEntityId: 'D4E5F6A7-B8C9-4D0E-8F1A-2B3C4D5E6F7A',
  dashboardsEntityId: '16273F1A-5520-4489-983F-D487022C87C8',
  dynamicFormsEntityId: '3F2504E0-4F89-11D3-9A0C-0305E82C3301',
};
